<template>
  <div class="model-detail-page">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>产品碳足迹</el-breadcrumb-item>
      <el-breadcrumb-item>模型管理</el-breadcrumb-item>
      <el-breadcrumb-item>模型详情</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="mainTab" class="main-tabs">
      <el-tab-pane label="目标与范围定义" name="scope">
        <placeholder-page />
      </el-tab-pane>
      <el-tab-pane label="生命周期模型" name="lifecycle">
        <div class="model-layout">
          <aside class="model-tree-panel">
            <div class="panel-title">
              <i class="el-icon-view"></i> 模型管理
            </div>
            <el-tree
              :data="modelTree"
              node-key="id"
              default-expand-all
              highlight-current
              :current-node-key="currentNodeId"
              :props="{ label: 'label', children: 'children' }"
              @node-click="handleNodeClick"
            />
          </aside>

          <div class="model-content">
            <el-tabs v-model="detailTab">
              <el-tab-pane label="输入输出" name="io">
                <div class="table-block">
                  <div class="table-title">输入</div>
                  <el-table :data="inputs" border stripe size="small">
                    <el-table-column prop="name" label="输入名称" min-width="180" />
                    <el-table-column prop="unitCategory" label="单位类别" width="100" />
                    <el-table-column prop="upstream" label="上游过程" min-width="160" />
                    <el-table-column prop="attribute" label="属性" width="120" />
                  </el-table>
                </div>
                <div class="table-block">
                  <div class="table-title">输出</div>
                  <el-table :data="outputs" border stripe size="small">
                    <el-table-column prop="name" label="输出名称" min-width="180" />
                    <el-table-column prop="unitCategory" label="单位类别" width="100" />
                    <el-table-column prop="downstream" label="下游过程" min-width="160" />
                    <el-table-column prop="attribute" label="属性" width="120" />
                  </el-table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="基本信息" name="basic">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="过程名称">{{ basicInfo.processName }}</el-descriptions-item>
                  <el-descriptions-item label="类别">{{ basicInfo.category }}</el-descriptions-item>
                  <el-descriptions-item label="地理位置">{{ basicInfo.location }}</el-descriptions-item>
                  <el-descriptions-item label="描述">{{ basicInfo.description }}</el-descriptions-item>
                </el-descriptions>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PlaceholderPage from '@/components/common/PlaceholderPage.vue'
import { getModelDetailData } from '@/api/modules/carbonFootprint'

export default {
  name: 'ModelDetail',
  components: { PlaceholderPage },
  data() {
    return {
      mainTab: 'lifecycle',
      detailTab: 'io',
      modelTree: [],
      currentNodeId: '',
      inputs: [],
      outputs: [],
      basicInfo: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const res = await getModelDetailData({ id: 'default' })
      const data = res.data
      this.modelTree = data.modelTree
      this.currentNodeId = data.currentNodeId
      this.inputs = data.inputs
      this.outputs = data.outputs
      this.basicInfo = data.basicInfo
    },
    handleNodeClick(node) {
      this.currentNodeId = node.id
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.model-detail-page {
  background: @card-bg;
  border-radius: @card-radius;
  box-shadow: @card-shadow;
  padding: 16px;
  min-height: calc(100vh - @header-height - 32px);
}

.main-tabs {
  margin-top: 12px;
}

.model-layout {
  display: flex;
  gap: 16px;
  min-height: 500px;
}

.model-tree-panel {
  width: 280px;
  flex-shrink: 0;
  border: 1px solid @border-color;
  border-radius: 4px;
  padding: 12px;

  .panel-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.model-content {
  flex: 1;
  min-width: 0;
}

.table-block {
  margin-bottom: 20px;

  .table-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
    padding-left: 8px;
    border-left: 3px solid @active-color;
  }
}
</style>
